import * as types from "../personalTrustpassActionTypes";

export default function personalTrustpass(state = {}, action) {
  switch (action.type) {
    case types.RECEIVE_PERSONAL_TRUSTPASS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/trustpass/reducers/personalTrustpassReducer.js